/**
 * Notification Bell
 *
 * @module NotificationBell
 *
 * Header button that shows unread count badge and toggles
 * the notification panel dropdown.
 */

import React, { useState } from 'react';
import { Bell } from '@phosphor-icons/react';
import { Button } from '@chatsdet/ui';
import { useNotifications } from '../hooks/useNotifications';
import { useFaviconBadge } from '../hooks/useFaviconBadge';
import { NotificationPanel } from './NotificationPanel';

export function NotificationBell() {
  const { unreadCount } = useNotifications();
  const [isOpen, setIsOpen] = useState(false);

  useFaviconBadge(unreadCount);

  return (
    <div className="relative">
      <Button
        variant="icon"
        iconOnly
        hoverAnimation="ring"
        tooltip="Notifications"
        onPress={() => setIsOpen(!isOpen)}
      >
        <Bell size={20} />
      </Button>
      {unreadCount > 0 && (
        <span className="pointer-events-none absolute top-1 right-1 flex h-3.5 min-w-3.5 items-center justify-center rounded-full bg-red-500 px-0.5 text-[9px] font-semibold text-white ring-2 ring-white dark:ring-neutral-900">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
      {isOpen && <NotificationPanel onClose={() => setIsOpen(false)} />}
    </div>
  );
}
